import React from 'react'

import { Spinner } from '@acorns/web-components'
import styled from 'styled-components'

const Center = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const CenteredSpinner = ({ className }: { className?: string }) => (
  <Center className={className}>
    <Spinner />
  </Center>
)

export default CenteredSpinner
